import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const sovereignEventLedgerService = createApi({
    reducerPath: 'sovereignEventLedgerService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['SovereignEventLedger'],
    endpoints: (builder) => ({
        getAllLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.getAllLedgerWithPagination}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getLedgerById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.getLedgerById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.saveLedger}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.updateLedger}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.deleteLedger}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.findAllLedger}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        generateDRPlan: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sovereignEventLedgerController.generateDRPlan}/${body.id}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllLedgerMutation,
    useGetLedgerByIdMutation,
    useSaveLedgerMutation,
    useUpdateLedgerMutation,
    useDeleteLedgerMutation,
    useFindAllLedgerMutation,
    useGenerateDRPlanMutation,
} = sovereignEventLedgerService;
